import React, { Component } from "react";

const menuItems = [
  { label: "Home", icon: "🏠" },
  { label: "About Us", icon: "ℹ️" },
  { label: "Services", icon: "⚙️" },
  { label: "Blog", icon: "📝" },
  { label: "Portfolio", icon: "🖼️" },
  { label: "Clients", icon: "🤝" },
  { label: "Team", icon: "👥" },
  { label: "Contact", icon: "📞" },
  { label: "Setting", icon: "⚙️" },
  { label: "Logout", icon: "🚪" },
];

class Sidebar extends Component {
  render() {
    const { activePage, onNavigate, isOpen, onClose } = this.props;

    return (
      <div className={`sidebar ${isOpen ? "sidebar-open" : ""}`}>

        {/* ✅ Close button (visible on mobile only) */}
        <button className="sidebar-close-btn" onClick={onClose} aria-label="Close menu">×</button>

        {/* Brand Name */}
        <div className="sidebar-logo">
          <img src="/tnalogo/tnalogo.png" alt="TNA Logo" className="logo-image" />
        </div>

        {/* User Info */}
        <div className="sidebar-user">
          <div className="avatar">A</div>
          <span>Hi, Admin</span>
        </div>

        {/* Navigation Links */}
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.label}
              className={`nav-item 
                ${activePage === item.label ? "active" : ""} 
                ${item.label === "Logout" ? "logout-btn" : ""}`}
              onClick={() => onNavigate(item.label)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

      </div>
    );
  }
}

export default Sidebar;
